export default __webpack_public_path__ + "static/media/Page4.885432bf.txt";